import { FalseReasonType } from '@shared/generated';

export const isFalseReasonType = (
  falseReason: string
): falseReason is FalseReasonType => {
  return Object.values(FalseReasonType).includes(
    falseReason as FalseReasonType
  );
};
